// extracted by mini-css-extract-plugin
module.exports = {"results":"styles_results__K06VG","rotate":"styles_rotate__kii00","rotate-reverse":"styles_rotate-reverse__9ySFv"};